/* eslint-disable arrow-body-style */
import notFoundIcon from '_images/not-found-128.png'

const NotFoundOrder = ({ message = 'Not Found Orders' }) => {
  return (
    <div
      className='d-flex flex-column justify-content-center align-items-center'
      style={{
        minHeight: '60vh',
        padding: '2rem'
      }}
    >
      <div
        className='d-flex justify-content-center align-items-center mb-4'
        style={{
          width: '120px',
          height: '120px',
          backgroundColor: '#f8f9fa',
          borderRadius: '20px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e9ecef'
        }}
      >
        <img
          src={notFoundIcon}
          alt="Not Found"
          style={{
            width: '64px',
            height: '64px',
            filter: 'brightness(0) saturate(100%) invert(60%) sepia(5%) saturate(10%) hue-rotate(314deg) brightness(90%) contrast(85%)'
          }}
        />
      </div>
      <h5 className='fw-bold text-muted mb-2'>{message}</h5>
      <p className='text-muted text-center mb-0' style={{ fontSize: '0.9rem', maxWidth: '300px' }}>
        Try adjusting your filters or search criteria to find what you&#39;re looking for.
      </p>
    </div>
  )
}

export default NotFoundOrder
